import { getQuizBySlug } from "@quiz/quiz-definitions";
import type { QuizDefinition } from "@quiz/quiz-core";

export interface RouteResult {
  slug: string;
  quiz?: QuizDefinition;
}

export function resolveCurrentQuiz(): RouteResult {
  const slug = window.location.pathname.replace(/^\/+/, "").split("/")[0] || "demo";
  return { slug, quiz: getQuizBySlug(slug) };
}
